// extracted by mini-css-extract-plugin
export default {"text":"Text_text__Pw1zW"};